module.exports = require("./sw-TZ.js");